import React, { useEffect } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import SigninWidget from "./app/auth/SigninWidget";
import Home from "./pages/Home/Home";
import KnowledgeGraph from "./pages/KnowledgeGraph/KnowledgeGraph";
import Favorite from "./pages/Favorite/Favorite";
import HistoryPage from "./pages/History/HistoryPage";
import Workbench from "./pages/Workbench/Workbench";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./app/auth/authConfig";
import DataDictionary from "./pages/Data Dictionary/DataDictionary";

const App = () => {
  useEffect(() => {
    localStorage.setItem("historyListFlag", true);
    localStorage.setItem("historyCollapse", false);
  }, []);

  return (
    <MsalProvider instance={msalInstance}>
      <Router>
        <Switch>
          <Route exact path="/" component={SigninWidget} />
          <Route path="/Home" component={Home} />
          <Route path="/KnowledgeGraph" component={KnowledgeGraph} />
          <Route path="/Workbench" component={Workbench} />
          <Route path="/Dashboard" component={Favorite} />
          <Route path="/history" component={HistoryPage} />
          <Route path="/Data-Dictionary" component={DataDictionary} />

        </Switch>
      </Router>
    </MsalProvider>
  );
};

export default App;